import React, { useEffect, useState } from 'react';
import Service from '../Service/Service';
import './Services.css';

const Services = () => {
    const [services, setServices] = useState([]);
    useEffect(() => {
        fetch('services.json')
            .then(res => res.json())
            .then(data => setServices(data));
    }, [])
    return (
        <div id='services' className='container mx-auto'>
            <h2 className='text-5xl font-bold font-serif text-center pt-5 mt-5'>My Services</h2>
            <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3 px-20 py-10'>
                {
                    services.map(service => <Service key={service.id} service={service} />)
                }
            </div>
        </div>
    );
};

export default Services;